module.exports = __webpack_public_path__ + "img/bg-confirm-turn-off.46796951.png";